import React from 'react';
import styled from 'styled-components';

import { Spinner } from '@xsolla/ui-core';

export const PreloaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Preloader = (): JSX.Element => {
  return (
    <PreloaderWrapper>
      <Spinner />
    </PreloaderWrapper>
  );
};

export default Preloader;
